import { usePageData } from 'lib/page-data/PageDataContext';
import { useMemo } from 'react';
import { useSitecoreContext } from './useSitecoreContext';

export const useArticle = (source, wildcardConfiguration) => {
  const data = usePageData(source);
  const { sitecoreContext: context } = useSitecoreContext();
  const config = context[wildcardConfiguration]!;

  return useMemo(() => ({ config, data }), [config, data]);
};
